import { Model, View } from "@lernetz/ts-lib";
import template from "./Podcast.html";

export class PodcastView extends View {
    constructor() {
        super({template});
    }
}

export class Podcast extends Model {
    public url: string;
    public selectors: string[];
    public imageUrl: string;
    episodes: any[];
    constructor(dto: any) {
        super(dto);
    }
}
